import {
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg6,
  texto,
  TipoIdentificacionEnumChoice,
  TipoServicioEnumChoice,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomTextField,
  CustomTextFieldNoForm,
} from "@/shared/components/ui";
import {
  IDataProspecto,
  IFormPreventa,
  NacionalidadEnum,
  Naps,
  Sector,
} from "@/shared/interfaces";
import GlobeEuropeAfricaIcon from "@heroicons/react/24/solid/GlobeEuropeAfricaIcon";
import {
  Alert,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  SvgIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { Edit } from "@mui/icons-material";
import LocationSearchingIcon from "@mui/icons-material/LocationSearching";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import {
  CoordenadasType,
  MapProps,
} from "@/shared/components/ui/Maps/CustomMapComponent";

interface TabResidenciaPreventaProps {
  dataProspecto: IDataProspecto;
  editSupervisor: boolean;
  form: UseFormReturn<IFormPreventa, any, IFormPreventa>;
  modalMapa: boolean;
  setModalMapa: React.Dispatch<React.SetStateAction<boolean>>;
  latLng: CoordenadasType;
  setLatLng: (value: CoordenadasType) => void;
  napsByCity: Naps[];
  isLoadingNapsByCity: boolean;
  MapComponent: React.FC<MapProps>;
  existeCobertura: boolean;
  dataSector: Sector[] | undefined;
  isLoadingSector: boolean;
  handleCoordenadaValida: (value: string, valid: boolean | undefined) => void;
  handleSelectSector: (cod: string) => Promise<void>;
  handleApiUbicacioActual: () => Promise<void>;
}

export default function TabResidenciaPreventa({
  dataProspecto,
  editSupervisor,
  form,
  modalMapa,
  MapComponent,
  latLng,
  napsByCity,
  isLoadingNapsByCity,
  existeCobertura,
  dataSector,
  isLoadingSector,
  setModalMapa,
  setLatLng,
  handleCoordenadaValida,
  handleSelectSector,
  handleApiUbicacioActual,
}: TabResidenciaPreventaProps) {
  const {
    control,
    formState: { errors },
  } = form;

  

  return (
    <>
      <Grid container spacing={3}>
        <Grid container item {...gridSizeMdLg12} alignItems={"center"}>
          <CustomTextField
            endAdornmentInput={editSupervisor ? <Edit color="action" /> : null}
            type="coordenada"
            control={form.control}
            name="coordenadas"
            defaultValue={form.getValues().coordenadas}
            size={{
              xs: 10,
              sm: 10,
              md: 10,
              lg: 10,
            }}
            label={texto.coordenadas}
            error={errors.coordenadas}
            startAdornment={
              <InputAdornment position="start">
                <SvgIcon fontSize="small">
                  <GlobeEuropeAfricaIcon />
                </SvgIcon>
              </InputAdornment>
            }
            helperText={errors.coordenadas?.message}
            onChangeValue={(value, valid) =>
              handleCoordenadaValida(value, valid)
            }
          />

          <Grid item xs={1} alignItems={"end"}>
            <Tooltip title="Abrir Mapa" placement="top">
              <IconButton onClick={() => setModalMapa(true)} size="small">
                <FmdGoodIcon color="info" />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={1} alignItems={"end"}>
            <Tooltip title="Obtener ubicación actual" placement="top">
              <IconButton
                onClick={() => handleApiUbicacioActual()}
                size="small"
              >
                <LocationSearchingIcon color="info" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>

        <Grid item xs={12} paddingBottom={"15px"}>
          <Typography
            variant="subtitle2"
            style={{
              color: "#6C737F",
            }}
          >
            {texto.permiso_ubicacion}
          </Typography>
        </Grid>

        {form.getValues().zona && (
          <>
            <CustomAutocomplete<Sector>
              size={gridSize}
              label="Seleccionar la Parroquia"
              name="sector"
              // options
              options={dataSector || []}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              defaultValue={form.getValues().sector}
              isLoadingData={isLoadingSector}
              control={control}
              error={errors.sector}
              helperText={errors.sector?.message}
              onChangeValue={(cod) => handleSelectSector(cod)}
            />

            <CustomTextField
              endAdornmentInput={editSupervisor ? <Edit color="action" /> : null}
              type="direccion"
              control={control}
              name="direccion"
              defaultValue={form.getValues().direccion || ""}
              size={gridSize}
              label={texto.direccion}
              error={errors.direccion}
              helperText={errors.direccion?.message}
              
            />

            {dataProspecto?.tipo_identificacion !=
              TipoIdentificacionEnumChoice.RUC && (
                <CustomTextFieldNoForm
                  disabled={true}
                  defaultValue={dataProspecto?.pais_data.nacionalidad}
                  size={gridSizeMdLg6}
                  label={texto.nacionalidad}
                />
              )}

            <CustomTextFieldNoForm
              disabled={true}
              defaultValue={NacionalidadEnum.ECUADOR}
              size={gridSizeMdLg6}
              label={texto.pais}
            />

            <CustomTextField
              disabled={true}
              type="none"
              control={control}
              name="provincia_nombre"
              defaultValue={form.getValues().provincia_nombre || ""}
              size={gridSizeMdLg6}
              label={texto.provincia}
              error={errors.provincia_nombre}
              helperText={errors.provincia_nombre?.message}
            />

            <CustomTextField
              disabled={true}
              type="none"
              control={control}
              name="ciudad_nombre"
              defaultValue={form.getValues().ciudad_nombre || ""}
              size={gridSizeMdLg6}
              label={texto.ciudad}
              error={errors.ciudad_nombre}
              helperText={errors.ciudad_nombre?.message}
            />

            <CustomTextField
              disabled={true}
              type="none"
              control={control}
              name="zona_nombre"
              defaultValue={form.getValues().zona_nombre || ""}
              size={gridSizeMdLg6}
              label={texto.zona}
              error={errors.zona_nombre}
              helperText={errors.zona_nombre?.message}
            />

            {form.getValues().tipo_servicio !==
              TipoServicioEnumChoice.RADIO && (
                <>
                  {isLoadingNapsByCity && (
                    <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                      <CircularProgress />
                    </Grid>
                  )}
                  {napsByCity.length == 0 && !isLoadingNapsByCity && (
                    <Grid item {...gridSizeMdLg12}>
                      <Alert variant="outlined" severity="warning">
                        No hay cajas disponibles para las coordendas asignadas
                      </Alert>
                    </Grid>
                  )}
                  {napsByCity.length != 0 && !isLoadingNapsByCity && (
                    <Grid item {...gridSizeMdLg12}>
                      <Alert variant="outlined" severity="success">
                        Cajas disponibles para las coordendas asignadas
                      </Alert>
                    </Grid>
                  )}
                </>
              )}
          </>
        )}

        {!existeCobertura && (
          <Grid item {...gridSizeMdLg12}>
            <Alert variant="outlined" severity="warning">
              Sin cobertura para las coordenas ingresadas
            </Alert>
          </Grid>
        )}
      </Grid>

      {modalMapa && (
        <ScrollableDialogProps
          open={modalMapa}
          title={`Mapa`}
          onCloseIcon={() => setModalMapa(false)}
          contentNode={
            <MapComponent
              key={"mapa-agenda"}
              coordenadas={latLng}
              napsByCity={napsByCity || []}
              setLatLng={setLatLng}
              canDragMarker
            />
          }
        />
      )}
    </>
  );
}
